import call from './call';
import { GET_SYSTEM_INFORMATION} from "../types";

export default (onFinishCallBack) => async (dispatch) =>
{
    const onResult= (result) =>
    {
        if(result && result[1].success)
        {
            let userInfo=result[1].userInfo;
            if(onFinishCallBack)
                onFinishCallBack(userInfo);
            dispatch({type: GET_SYSTEM_INFORMATION, payload: {systemInfo: userInfo}});
        }

    };
    dispatch(call("SystemService/getSystemInformation",{},onResult));
};